const ORGANIZATIONAL_UNIT_DRAG_TYPE = "organizationalUnit";

export { ORGANIZATIONAL_UNIT_DRAG_TYPE };
